jQuery(document).ready(function($) {

    $( ".bloc_colones" ).each(function( index ) {

        var parent = $(this)
        var cibleArgs = parent.find(".colone")

        var mm = gsap.matchMedia()

        // Desktop : montée en cascade liée au scroll
        mm.add("(min-width: 1024px)", function() {
            gsap.from( cibleArgs, {
                y : +200,
                duration: 1,
                stagger: .2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: parent,
                    markers: false,
                    start: "top 100%",
                    end: "top 50%",
                    scrub: 1,
                }

            })
        })

        // Tablette / mobile : les éléments sont empilés, chacun apparaît
        // à son arrivée à l'écran (un décalage commun de 200px ferait chevaucher les lignes)
        mm.add("(max-width: 1023.98px)", function() {
            cibleArgs.each(function() {
                gsap.from(this, {
                    y: 60,
                    duration: .6,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: this,
                        start: "top 95%",
                    }
                })
            })
        })

    })

});